export default __webpack_public_path__ + "static/media/logo-cmtech-small-2.746d6d85.png";